export default "__VITE_ASSET__BKWod5pl__"